import BaseModel from './BaseModel';

// Model representing a tuple[str, int] entry
export class LeaderboardEntry extends BaseModel {
  init(data) {
    // Expecting data to be [string, number] array or {name, count} object
    if (Array.isArray(data)) {
      this.name = data[0];
      this.count = data[1];
    } else {
      this.name = data.name;
      this.count = data.count;
    }
  }
}

export class TemplateLibraryLeaderboardModel extends BaseModel {
  init(data) {
    // data should be list[tuple[str, int]]
    this.entries = (data || []).map(entry => new LeaderboardEntry(entry));
  }

  // Getter for easy access to entries
  get items() {
    return this.entries;
  }
}

export class TemplateLibraryCategoryLeaderboardModel extends BaseModel {
  init(data) {
    // data should be list[tuple[str, int]]
    this.entries = (data || []).map(entry => new LeaderboardEntry(entry));
  }

  // Getter for easy access to entries
  get items() {
    return this.entries;
  }
}

export default class TemplateLibraryMetricsModel extends BaseModel {
  init(data) {
    this.template_leaderboard = data.template_leaderboard ? new TemplateLibraryLeaderboardModel(data.template_leaderboard) : new TemplateLibraryLeaderboardModel([]);
    this.template_category_leaderboard = data.template_category_leaderboard ? new TemplateLibraryCategoryLeaderboardModel(data.template_category_leaderboard) : new TemplateLibraryCategoryLeaderboardModel([]);
  }

  get templateLeaderboard() {
    return this.template_leaderboard;
  }

  get templateCategoryLeaderboard() {
    return this.template_category_leaderboard;
  }
}
